export var ENTITY = "contract";
export var REDUCER_KEY = "CONTRACT_V2";
export var BASE_PATH_ENTITY = "contracts";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
